import { Component } from '@angular/core';
import { HomeComponent } from './home/home.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [HomeComponent]
})
export class AppComponent {
  title = 'InExtenso - Mon Compte';
}
